import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import styles from "./styles/menu-wrapper.css.js";
import withStyles from "components/with-styles";
import Drawer from "@material-ui/core/Drawer";

const MenuWrapper = ({ children, className, classes, open }) => (
  <Drawer
    open={open}
    variant="permanent"
    classes={{
      paper: cn(className, classes.dashboard_menu_drawer, !open && classes.dashboard_menu_drawer__closed),
    }}
  >
    {children}
  </Drawer>
);

MenuWrapper.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Indica si el menú lateral del dashboard está desplegado
   **/
  open: PropTypes.bool,
};

export default withStyles(styles)(MenuWrapper);
